import { create } from 'jsondiffpatch';
import * as jsondiffpatchHtml from 'jsondiffpatch/lib/formatters/html';
import { diffWords } from 'diff';

export async function skillDiffAsHtml(skill1, skill2) {
  const prepareForComparison = skill => {
    delete skill.lastModified;
    delete skill.lastModifiedBy;
    delete skill.version;
  };

  prepareForComparison(skill1);
  prepareForComparison(skill2);

  const instance = create({
    matchByPosition: true,
    arrays: {
      detectMove: true,
      includeValueOnMove: true
    },
    objectHash: function(obj) {
      return obj.name || obj.id || JSON.stringify(obj);
    },
    textDiff: {
      minLength: 1
    }
  });

  const delta = instance.diff(skill1, skill2);

  const replacements = [];

  async function hashString(message) {
    const msgBuffer = new TextEncoder().encode(message);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  var diffContent = async object => {
    const promises = !object
      ? [Promise.resolve()]
      : Object.getOwnPropertyNames(object).map(async prop => {
          if (['description', 'displayDescription', 'content'].includes(prop)) {
            if (!object[prop] || !Array.isArray(object[prop])) {
              return diffContent(object[prop]);
            }

            const left = object[prop][1] || '';
            const right = object[prop][0] || '';

            const before = diffWords(left, right);
            const after = diffWords(right, left);

            let beforeValue = '';
            let afterValue = '';

            before.forEach(val => {
              if (val.added) {
                beforeValue += `<span class='added'>${val.value}</span>`;
              } else if (val.removed) {
                beforeValue += `<span class='deleted'>${val.value}</span>`;
              } else {
                beforeValue += `<span>${val.value}</span>`;
              }
            });

            after.forEach(val => {
              if (val.added) {
                afterValue += `<span class='added'>${val.value}</span>`;
              } else if (val.removed) {
                afterValue += `<span class='deleted'>${val.value}</span>`;
              } else {
                afterValue += `<span>${val.value}</span>`;
              }
            });

            const idLeft = await hashString(left);
            const idRight = await hashString(right);
            object[prop][0] = idLeft;
            object[prop][1] = idRight;

            replacements.push({
              what: object[prop][0],
              with: `<div class='content-dif hidden'><span>"</span>${beforeValue}<span>"</span></div>`
            });
            replacements.push({
              what: object[prop][1],
              with: `<div class='content-dif'><span>"</span>${afterValue}<span>"</span></div>`
            });
          }

          if (typeof object[prop] === 'object' && object[prop]) {
            return diffContent(object[prop]);
          }
        });

    return Promise.all(promises);
  };

  await diffContent(delta);

  let html = delta ? jsondiffpatchHtml.format(delta, skill1) : '<div class="no-diff">Versions are equal</div>';
  replacements.forEach(rep => {
    html = html.replaceAll(`<pre>&quot;${rep.what}&quot;</pre>`, rep.with);
  });

  return html;
}
